import { AfterViewInit, Component, DestroyRef, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Hub } from 'aws-amplify/utils';

import { authActions } from './store/auth/auth.actions';
import { selectFormularStoreIsLoadingAFormular } from './store/formular/formular.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { selectDokumentContentIsLoading } from './store/dokumente-unternehmen/dokumente-unternehmen.selectors';
import { IdleUserService } from './service/idle-user.service';
import { maintenanceScheduleActions } from './store/maintenance-schedule/maintenance-schedule.actions';
import { environment } from '../environments/environment';
import { selectMaintenanceIsActiveFiltered } from './store/maintenance-schedule/maintenance-schedule.selectors';
import { Router } from '@angular/router';
import { selectLoggedIn } from './store/auth/auth.selectors';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
    private store = inject(Store);
    private destroyRef = inject(DestroyRef);
    private idelUserService = inject(IdleUserService);
    private router = inject(Router);

    private maintenanceTimer: NodeJS.Timeout;
    private maintenanceIsActive: boolean;
    private titleService = inject(Title);
    private renderer = inject(Renderer2);

    authListener = (data: { payload: { event: string } }): void => {
        switch (data.payload.event) {
            case 'signedIn':
                this.store.dispatch(authActions.updateLoginDetails({ isLogin: true }));
                break;
            case 'signedOut':
                break;
            case 'tokenRefresh':
                this.store.dispatch(authActions.updateToken());
                break;
            case 'tokenRefresh_failure':
                this.store.dispatch(authActions.postChangeUserToLoggedOut({ timeout: true }));
                break;
            case 'signInWithRedirect':
                break;
            case 'signInWithRedirect_failure':
                break;
            case 'customOAuthState':
                break;
            default:
        }
    };

    /**
     * activated listener to authentication events from amplify
     */
    ngOnInit(): void {
        this.renderer.setAttribute(document.documentElement, 'portal-version', environment.version);
        if (environment.titlePrefix !== '') {
            const title = environment.titlePrefix + this.titleService.getTitle();
            this.titleService.setTitle(title);
        }
        Hub.listen('auth', this.authListener);
        this.store.select(selectFormularStoreIsLoadingAFormular).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (isLoading) => {
                document.body.className = isLoading ? 'progress-cursor' : '';
            }
        );
        this.store.select(selectDokumentContentIsLoading).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (isLoading) => {
                document.body.className = isLoading ? 'progress-cursor' : '';
            }
        );
        this.store.select(selectMaintenanceIsActiveFiltered).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (maintenanceIsActive) => {
                if (!this.maintenanceIsActive && maintenanceIsActive && !this.router.url.includes('formular')) {
                    this.router.navigate(['/wartungsseite']);
                }
                this.maintenanceIsActive = maintenanceIsActive;
            }
        );
        this.store.select(selectLoggedIn).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (isLoggedIn) => {
                if (isLoggedIn) {
                    this.maintenanceTimer = setTimeout(() => (this.handleMaintenanceCheck()), (environment.maintenanceEnv.maintenanceCheckTimeInSec * 1000));
                } else {
                    clearTimeout(this.maintenanceTimer);
                }
            }
        )
    }
    ngAfterViewInit(): void {
        this.idelUserService.initIdleManagmentForTab(this.destroyRef);
    }

    ngOnDestroy(): void {
        clearTimeout(this.maintenanceTimer);
    }

    private handleMaintenanceCheck(): void {
        this.store.dispatch(maintenanceScheduleActions.updateCheckMaintenanceSchedule());
        this.maintenanceTimer = setTimeout(() => (this.handleMaintenanceCheck()), (environment.maintenanceEnv.maintenanceCheckTimeInSec * 1000))
    }
}
